import {
    AfterViewInit, ChangeDetectorRef,
    Component, ComponentFactoryResolver,
    Inject, OnDestroy,
    OnInit,
    QueryList,
    ViewChild,
    ViewChildren,
    ViewContainerRef
} from '@angular/core';
import { SimpleMatDataSource } from '../../common/providers/simple-mat-data-source';
import { FeedbackRights, mapFeedbackItemRightsToRowRights } from '../../feedback/providers/feedback-rights';
import { FeedbackAthleteAnswerProvider } from '../../feedback/providers/feedback-athlete-answer-provider';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { UsersProvider } from '../../users/providers/users-provider';
import { ArrayUtils } from '../../common/providers/array-utils';
import { CurrentUserRolesProvider } from '../../organizations/providers/current-user-roles-provider';
import { CurrentUser } from "../../common/providers/current-user";
import { Title } from '@angular/platform-browser';
import { ConfigProvider } from "../../config-provider.service";
import BaseAthleteAnswer from '../../feedback/athlete-answers/base-athlete-answer';

import * as athleteAnswersComponents from '../../feedback/athlete-answers/athlete-answers';
import { forkJoin, map, Subscription } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { importToArray, UtilsProvider } from "../../common/providers/utils-provider.service";
import { AppDatePipe } from "../../common/pipes/app-date";
import { Organization } from "../../common/models/organization";
import { Athlete } from "../../common/models/athlete";
import { User } from "../../common/models/user";
import { KeyValuePipe, NgForOf, NgIf } from "@angular/common";
import { MobilePageContentComponent } from "../../common/components/mobile-page-content/mobile-page-content";
import { MobileHeaderComponent } from "../../common/components/mobile-header/mobile.header";
import { MobileSideMenuComponent } from "../../common/components/mobile-side-menu/mobile.side-menu.component";
import { Error401Component } from "../../common/components/error-401/error-401";
import { Error404Component } from "../../common/components/error-404/error-404";
import { ModuleContentComponent } from "../../common/components/module-content/module-content";
import { MatCardContent } from "@angular/material/card";
import { MatDivider } from "@angular/material/divider";
import { AthletesProvider } from "../../athletes/providers/athletes-provider";
import { CoachesProvider } from "../../coaches/providers/coaches-provider";
import { AthleteCoach } from "../../common/models/athlete-coach";

const ATHLETE_ANSWER_COMPONENTS = importToArray(athleteAnswersComponents);
const ATHLETE_ANSWER_COMPONENTS_MAP = ATHLETE_ANSWER_COMPONENTS.reduce<any>((result, value: any, index, array) => {
    result[value.type] = value;
    return result;
}, {});

@Component({
  selector: 'app-mobile-feedback-show-container',
  templateUrl: './mobile.feedback-show-container.component.html',
  styleUrls: ['./mobile.feedback-show-container.scss'],
  standalone: true,
  imports: [
    AppDatePipe,
    TranslateModule,
    KeyValuePipe,
    NgIf,
    NgForOf,
    MobilePageContentComponent,
    MobileHeaderComponent,
    MobileSideMenuComponent,
    Error401Component,
    Error404Component,
    ModuleContentComponent,
    MatCardContent,
    MatDivider
  ]
})
export class MobileFeedbackShowContainerComponent implements OnInit, AfterViewInit, OnDestroy {

    public pageTitle = 'Tests';
    public isLoading = true;
    public is401 = false;
    public is404 = false;

    public array = Array;

    public dataSource: SimpleMatDataSource = new SimpleMatDataSource([]);
    public columns: string[] = ['name', 'createDate', 'smiley'];

    public organization: Organization = {} as Organization;
    public athleteUser: User = {} as User;
    public feedbackAthleteAnswer: any;
    public rights: FeedbackRights = new FeedbackRights(this.utils);

    @ViewChild(MatPaginator, {static: false}) public paginator: MatPaginator | undefined;

    @ViewChildren('athleteAnswerRef', { read: ViewContainerRef })
    public athleteAnswerRefs: QueryList<ViewContainerRef> = {} as QueryList<ViewContainerRef>;

    public answers: any;

    private factoryResolver;

    private componentRef: any;
    private subscriptions: Subscription[] = [];

    constructor(
    @Inject(ComponentFactoryResolver) factoryResolver: ComponentFactoryResolver,
                                      private feedbackAthleteAnswerProvider: FeedbackAthleteAnswerProvider,
                                      private route: ActivatedRoute,
                                      private translator: TranslateService,
                                      private userProvider: UsersProvider,
                                      private cd: ChangeDetectorRef,
                                      private arrayUtils: ArrayUtils,
                                      private utils: UtilsProvider,
                                      private currentUserRoles: CurrentUserRolesProvider,
                                      private currentUser: CurrentUser,
                                      private title: Title,
                                      public conf: ConfigProvider,
                                      public datepipe: AppDatePipe,
    private athletesProvider: AthletesProvider,
    private coachesProvider: CoachesProvider,
    ) {
        this.factoryResolver = factoryResolver;
    }

    public ngOnInit(): void {
        this.subscriptions.push(
            this.route.data.subscribe((data: any) => { // { organization: Organization; athlete: Athlete; feedbackAthleteAnswer: any }
              this.organization = data.organization;
              this.athleteUser = data.athlete;
              this.feedbackAthleteAnswer = data.feedbackAthleteAnswer;
              this.rights.setItemRightsList(this.feedbackAthleteAnswer);
              this.rights.evaluateScreenRights({
                  rolesIds: this.currentUserRoles.getRolesIds(this.organization.id!)
              });
              if (!this.rights.LIST) {
                  this.is401 = true;
              }
              if (!this.rights.getItemRightsList().view) {
                this.is401 = true;
              }

              this.createPageTitle();
              this.isLoading = false;
            })
        );
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public async ionViewDidLoad() {
        this.subscriptions.push(
            this.athleteAnswerRefs.changes.subscribe(() => {
                this.loadComponents();
            })
        );

        await this.loadDeposits();
    }

    public async loadDeposits() {
        const grouped = this.arrayUtils.groupBy(this.feedbackAthleteAnswer.answers, (a) => a.feedbackQuestionId);
        this.feedbackAthleteAnswer['answersGrouped'] = grouped;
        this.answers = await grouped;
    }

    public ngAfterViewInit() {
        this.ionViewDidLoad();
        this.cd.detectChanges();
    }


    private loadComponents() {
      this.athleteAnswerRefs.forEach((viewContainerRef, i) => {
          // get map item by Map index, not by his key
          const mapItem = this.answers.get(Array.from(this.answers.keys())[i]);

          // map item is an array
          const type = mapItem[0].questionType;

          const componentFactory = this.factoryResolver.resolveComponentFactory(ATHLETE_ANSWER_COMPONENTS_MAP[type]);
          this.componentRef = viewContainerRef.createComponent(componentFactory, undefined, viewContainerRef.injector);
          // this.componentRef.changeDetectorRef.detectChanges();
          const component = this.componentRef.instance as BaseAthleteAnswer;
          component.data = mapItem;
      });

      this.cd.detectChanges();
    }

    private createPageTitle() {
        this.pageTitle = this.translator.instant('FeedbackOf').replace('{{date}}', this.datepipe.transform(this.feedbackAthleteAnswer.feedback.answeredAt, 'mediumDate'));
        this.title.setTitle(this.pageTitle + ' | ' + this.conf.platformName);
    }
}
